/* eslint-disable max-len */
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ErrorCode } from '@constants';
import { useNavigate } from 'react-router-dom';
import { useUrlJump, useBehaviorData } from '@hooks';
import { useLogin } from '@components/login-panel/hooks';
import { getFeedbackData, updateTracking } from '@api';

const feedbackDataMap = new Map();

const useFeedback = () => {
  const { setIsInvalidBarShow } = useLogin();
  const { policyId } = useSelector((state) => state.claim);
  const {
    policyList, reasonList, platform, claimList,
  } = useSelector((state) => state.policy);
  const [isLoading, setIsLoading] = useState(true);
  const [list, setList] = useState([]);
  const [detailInfo, setDetailInfo] = useState({ history: [] });
  const [tabIndex, setTabIndex] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const setReportData = useBehaviorData();

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  const getFeedbackList = async (claimId) => {
    setIsLoading(true);
    const resp = await getFeedbackData({ policyId, claimId });
    if (resp.code !== 0) {
      navigate('../error', { state: { code: resp.code, backStep: -2 } });
      setIsLoading(false);
      return;
    }
    const { data: currentReturnDetail = {} } = resp;
    feedbackDataMap.set(claimId, currentReturnDetail);
    const currentList = claimList.length > 0 ? claimList : currentReturnDetail.relatedClaims;
    const currentTab = currentList
      ?.findIndex((v) => v.claimId === currentReturnDetail.claimId);
    setList(currentList);
    setDetailInfo(currentReturnDetail);
    setTabIndex(currentTab);
    setIsLoading(false);
  };

  const onChange = async (e, tab) => {
    setOpen(false);
    const info = feedbackDataMap.get(list[tab]?.claimId);
    if (info) {
      setTabIndex(tab);
      setDetailInfo(info);
    } else {
      getFeedbackList(list[tab].claimId, tab);
    }
  };

  const reportIssueClick = () => {
    setReportData({ reportIssueTime: `${Date.now()}` });
    useUrlJump({
      policyList, navigate, dispatch, setIsInvalidBarShow, platform,
    });
  };

  const handleSubmit = async (values) => {
    const resp = await updateTracking(detailInfo.claimId, { ...values, trackingNumber: values.trackingNumber.replace(/\s*/g, '') });
    if (!resp) {
      navigate('../error', { state: { code: ErrorCode.Wrong, backStep: -2 } });
      setIsLoading(false);
      return;
    }
    const { code, message } = resp;
    if (code === 0) {
      getFeedbackList(detailInfo.claimId);
    } else {
      console.log(message);
    }
  };

  return {
    tabIndex,
    detailInfo,
    list,
    isLoading,
    reasonList,
    platform,
    open,
    policyId,
    claimList,
    handleSubmit,
    toggleDrawer,
    onChange,
    getFeedbackList,
    reportIssueClick,
  };
};
export default useFeedback;
